// extracted by mini-css-extract-plugin
export default {"card":"i5-z"};